import cookie from '@ms/utils/cookie.js'
import { getOperId } from 'composables/useRegion.js'
import { isApp, isIOS, isGamesApp } from 'wap/hybrid/device.js'
import { isCurrentPageEnabledTheme, getThemeMode, getSystemThemeMode, isThemeModeExists } from '@ms/utils/theme.js'
import { THEME_MODE } from '@ms/config/theme.js'

const getSchemeChoose = () => {
  if (!isCurrentPageEnabledTheme) {
    return THEME_MODE.DARK.value
  }

  const themeMode = getThemeMode()

  // systemThemeMode
  if (themeMode === THEME_MODE.SYSTEM.value) {
    const systemThemeMode = getSystemThemeMode()
    if (isThemeModeExists(systemThemeMode)) {
      return systemThemeMode
    }
  }

  return themeMode
}

// 获取请求头
export const getHeaders = () => {
  const headers = {
    operid: getOperId(),
    ApiLevel: 2,
    devMem: navigator.deviceMemory || '',
    network: navigator.connection?.effectiveType
  }

  if (isApp()) {
    headers.AppVersion = cookie.get('appVersion') || window.msUserAgent?.appVersion || ''

    if (isGamesApp()) {
      headers.clientid = 'games-wv'
    } else {
      headers.clientid = 'app-wv'
    }

    if (isIOS()) {
      headers.platform = 'ios'
    } else {
      headers.platform = 'android'
    }
  } else if (process.env.PLATFORM === 'desktop') {
    Object.assign(headers, {
      clientid: 'WEB',
      platform: 'WEB'
    })
  } else {
    Object.assign(headers, {
      clientid: 'wap',
      platform: 'WAP',
      schemeChoose: getSchemeChoose()
    })
  }

  return headers
}

// 有些页面需要 app 提供的 header 参数
export const appHeaders = {
  status: false,
  value: {}
}
